export default "__VITE_ASSET__CNr1b0t1__"